import { copyCostTemplate } from '@/services/product'
import { Form, Input, message } from 'antd'
import { useEffect, useState } from 'react'
import { STriggerModal } from 'shj-components'

const CopyModal = (props: {
  open: boolean
  record: Record<string, any>
  listRef: any
  onCancel: () => void
}) => {
  const { open, record, listRef, onCancel } = props

  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  // 复制费用模版
  const handleOk = () => {
    setLoading(true)
    copyCostTemplate({
      costTemplateId: record.id,
      templateName: form.getFieldsValue().name,
    })
      .then((res: any) => {
        message.success(res.message || '操作成功')
        onCancel()
        listRef.current?.reload()
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    if (open) {
      form.setFieldsValue({
        name: record.templateName,
      })
    }

    return () => {
      form.resetFields()
    }
  }, [open, form, record.templateName])

  return (
    <STriggerModal
      title="复制模板"
      open={open}
      onOk={handleOk}
      onCancel={onCancel}
      width={500}
      destroyOnClose
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="新对象名称"
          name="name"
          rules={[{ required: true, message: '请输入新对象名称' }]}
        >
          <Input placeholder="请输入新对象名称" maxLength={30} showCount />
        </Form.Item>
      </Form>
    </STriggerModal>
  )
}

export default CopyModal
